<aside
  class="v-one-sidebar"
  [class.v-one-sidebar--collapsed]="collapsedState()"
>
  <div class="v-one-sidebar__header">
    <v-one-button
      [icon]="'dots'"
      [iconType]="ICON_TYPE.FILLED"
      [variant]="'primary'"
      [className]="'v-one-sidebar__toggle'"
      (buttonClick)="toggleSidebar()"
      [attr.aria-label]="collapsedState() ? 'Expand menu' : 'Collapse menu'"
    >
    </v-one-button>
  </div>

  <nav class="v-one-sidebar__nav">
    <ul class="v-one-sidebar__list">
      @for (item of items(); track item.id) {
        <li class="v-one-sidebar__item">
          <div
            class="v-one-sidebar__link"
            [class.v-one-sidebar__link--active]="isItemActive(item)"
            [class.v-one-sidebar__link--has-children]="hasChildren(item)"
          >
            <button
              class="v-one-sidebar__link-button"
              (click)="navigateToItem(item)"
              [attr.aria-label]="item.label | translate"
            >
              <span class="v-one-sidebar__link-content">
                <v-one-icon
                  [name]="item.icon"
                  [type]="ICON_TYPE.FILLED"
                  color="white"
                  className="v-one-sidebar__icon"
                >
                </v-one-icon>

                @if (!collapsedState()) {
                  <span class="v-one-sidebar__label">{{
                    item.label | translate
                  }}</span>
                }
              </span>
            </button>

            @if (hasChildren(item) && !collapsedState()) {
              <button
                class="v-one-sidebar__chevron-button"
                (click)="toggleExpanded(item.id)"
                [attr.aria-expanded]="isItemExpanded(item.id)"
                [attr.aria-label]="
                  isItemExpanded(item.id)
                    ? 'Collapse ' + item.label
                    : 'Expand ' + item.label
                "
              >
                <div
                  [class]="
                    'v-one-sidebar__chevron' +
                    (isItemExpanded(item.id)
                      ? ' v-one-sidebar__chevron--rotate'
                      : '')
                  "
                >
                  <v-one-icon
                    name="chevronDown"
                    [type]="ICON_TYPE.OUTLINE"
                    color="white"
                  >
                  </v-one-icon>
                </div>
              </button>
            }
          </div>

          @if (
            hasChildren(item) && isItemExpanded(item.id) && !collapsedState()
          ) {
            <ul class="v-one-sidebar__submenu">
              @for (child of item.children; track child.id) {
                <li class="v-one-sidebar__subitem">
                  <button
                    class="v-one-sidebar__sublink"
                    [class.v-one-sidebar__sublink--active]="isItemActive(child)"
                    (click)="navigateToItem(child)"
                  >
                    <span class="v-one-sidebar__dot"></span>
                    <span class="v-one-sidebar__label">{{
                      child.label | translate
                    }}</span>
                  </button>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
    <div class="v-one-language-button-show">
      <app-language-selector></app-language-selector>
    </div>
  </nav>
</aside>
